import {replaceRule} from "@/utils/data.ts";
import React from "react";
import {isArray} from "lodash-es";
import {Tooltip} from "antd";

export const config = {
  rowSelection: false,
  columns: [
    {
      title: '序号',
      dataIndex: 'orderNumber',
      width: 80,
      ellipsis: true
    },
    {
      title: '标配SKU名称',
      dataIndex: 'showName',
      width: 300,
      ellipsis: true
    },
    {
      title: '标配SKU_ID',
      dataIndex: 'productSkuId',
      width: 200,
      ellipsis: true
    },
    {
      title: '关联SPU_ID',
      dataIndex: 'productId',
      width: 200,
      ellipsis: true,
    },
    {
      title: '关联物料/施工SPU编码',
      width: 200,
      dataIndex: ['product','sourceCode'],
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '品牌',
      width: 120,
      dataIndex: ['productSku','brandName'],
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '产品类型',
      width: 120,
      name: 'shops',
      dataIndex: ['productSku','prodTypeName'],
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '标配适用门店',
      dataIndex: 'orgName',
      width: 180,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: 'SKU适用门店',
      width: 220,
      dataIndex: ['productSku'],
      render: (_, record: Record<string, any>)=>{
        const shopList = isArray(record?.productSku?.shops)?record?.productSku?.shops:[];
        const txt = shopList?.map(item => item.companyName).join(',');
        return <Tooltip title={txt||""} placement="topLeft">
          <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',width:210}}>{txt||""}</div>
        </Tooltip>
      },
    },
    {
      title: '是否必选',
      dataIndex: 'requiredFlag',
      width: 120,
      render: (text: any) => {
        return text ? '是' : '否'
      },
    },
    {
      title: '预算量规则',
      dataIndex: ['standardJson', 'budgetRule'],
      width: 150,
      ellipsis: {
        showTitle: true,
      },
      render: (text: any) => {
        return text ? replaceRule(text): ''
      },
    },
    {
      title: '是否可编辑量',
      dataIndex: 'editFlag',
      width: 160,
      render: (text: any) => {
        return text ? '是' : '否'
      },
    },
    { title: '开始日期', dataIndex: 'startDate', width: 120, itemType: 'date' },
    { title: '结束日期', dataIndex: 'endDate', width: 120, itemType: 'date' },
    {
      title: 'SKU状态',
      dataIndex: 'enabled',
      name: 'enabled',
      width: 100,
      fixed: 'right',
      render: 'enableRender',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 100,
      fixed: 'right',
      render: 'actionRender'
    },
  ],
  search: [
    {
      label: '标配SKU名称',
      name: 'productSkuNameKey',
    },
    { label: '标配SKU_ID', name: 'productSkuId' },
    {
      label: '关联SPU_ID',
      name: 'productId',
    },
    {
      label: '关联物料/施工SPU编码',
      name: 'productSourceCode',
    },
    {
      label: '品牌',
      name: 'productSkuBrandId',
      itemType: 'select',
      data: 'brandList',
      key: 'value',
      labelKey: 'label',
    },
    {
      label: '标配适用门店',
      name: 'orgId',
      itemType: 'select',
      key: 'id',
      labelKey: 'companyName',
      data: 'companyList',
    },
  ],
  footer: false,
}
